import { Button } from "@/components/ui/button";
import { useAdminModals, useLoadingStore } from "@/zustand/store";

export const referralColumn = [
  {
    accessorKey: "id",
    header: "ID",
  },
  {
    header: "Name",
    cell: ({ row }) => (
      <div>
        {row.original.firstName} {row.original.lastName}
      </div>
    ),
  },
  {
    accessorKey: "email",
    header: "Email",
  },
  {
    header: "Balance",
    cell: ({ row }) => (
      <div className="text-primary-green font-medium">
        USD{row.original.balance.toFixed(2)}
      </div>
    ),
  },
  {
    header: "Referral Earnings",
    cell: ({ row }) => (
      <div className="font-medium">
        USD{row.original.totalCommisions.toFixed(2)}
      </div>
    ),
  },
];
